import { Injectable } from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {Observable} from 'rxjs';
import {DefaultSettingsService} from './default-settings-service.service';
import {ModalReviewGroupCreateComponent} from './modals/modal-review-group-create/modal-review-group-create.component';
import {ModalReviewGroupEditComponent} from './modals/modal-review-group-edit/modal-review-group-edit.component';

@Injectable({
  providedIn: 'root'
})
export class  ReviewActionService extends ExcTranslation {

  constructor(private excRest: ExcRestService, private excDss: DefaultSettingsService) {
    super();
  }
  public CreateGroupWizard(Audit: any) {
    const _self = this;
    const obs: Observable<boolean> = Observable.create( o => {
      const url = _self.excRest.computeUrl('ReviewGroupR_ListCandidates', {AuditID: Audit['AuditID']});
      _self.excRest.get(url, {}).subscribe(cd => {
        if (cd && cd.success === true) {
          ExcCoreModule.showModal(ModalReviewGroupCreateComponent, null, 'xl', {Audits: null, PossibleAudits: cd.data, IsWizardMode: true}, false).subscribe(dc => {
            if (dc.proceed === true) {
              let auditids = '';
              for (let i = 0; i < dc.Audits.length; i++) {
                auditids = auditids + (i === 0   ? '' : '|') + dc.Audits[i]['AuditID'];
              }
              const url2 = _self.excRest.computeUrl('ReviewGroupC', {});
              _self.excRest.put(url2, {AuditLead: dc.AuditLead, GroupHeader: dc.GroupHeader, GroupText: dc.GroupText, AuditIDs: auditids}, {}).subscribe(res => {
                o.next(true);
                o.complete();
              });
            } else {
              o.next(false);
              o.complete();
            }
          });
        } else {
          o.next(false);
          o.complete();
        }
      });
    });
    return obs;
  }
  public CreateGroupManual(Audits: any[], PossibleAudits: any[]) {
    const _self = this;
    const obs: Observable<boolean> = Observable.create( o => {
      ExcCoreModule.showModal(ModalReviewGroupCreateComponent, null, 'xl', {Audits: Audits, PossibleAudits: PossibleAudits, IsWizardMode: false}, false).subscribe(dc => {
          if (dc.proceed === true) {
            let auditids = '';
            for (let i = 0; i < dc.Audits.length; i++) {
              auditids = auditids + (i === 0 ? '' : '|') + dc.Audits[i]['AuditID'];
            }
            const url = _self.excRest.computeUrl('ReviewGroupC', {});
            _self.excRest.put(url, {AuditLead: dc.AuditLead, GroupHeader: dc.GroupHeader, GroupText: dc.GroupText, AuditIDs: auditids}, {}).subscribe(res => {
              o.next(true);
              o.complete();
            });
          } else {
            o.next(false);
            o.complete();
          }
        });
      });
    return obs;
  }
  public EditGroup(Audits: any[]) {
    const _self = this;
    const obs: Observable<boolean> = Observable.create( o => {
      ExcCoreModule.showModal(ModalReviewGroupEditComponent, null, 'xl', {Audits: Audits}, false).subscribe(dc => {
        if (dc.proceed === true) {
          let auditids = '';
          for (let i = 0; i < Audits.length; i++) {
            auditids = auditids + (i === 0 ? '' : '|') + Audits[i]['AuditID'];
          }
          const url = _self.excRest.computeUrl('ReviewGroupC', {});
          _self.excRest.put(url, {AuditLead: dc.AuditLead, GroupHeader: dc.GroupHeader, GroupText: dc.GroupText, AuditIDs: auditids}, {}).subscribe(res => {
            o.next(true);
            o.complete();
          });
        } else {
          o.next(false);
          o.complete();
        }
      });
    });
    return obs;
  }
}
